/** Matches on the literal 'edit-session' or 'thread' */
export function match(value: string) {
	return value === 'edit-session' || value === 'thread';
}
